import React from "react";
import { Link } from "react-router-dom";
import { workItems } from "../data/siteContent";

function Services() {
  function ServiceItem({
    delay,
    description,
    image,
    linkLabel,
    name,
    slug,
    type,
  }) {
    return (
      <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay={delay}>
        <article className="service-item position-relative service-card">
          <div className="service-image-wrap">
            <img src={image} className="img-fluid service-image" alt={name} />
          </div>
          <span className="service-badge">{type}</span>
          <h4>
            <Link to={`/projects/${slug}`} className="stretched-link">
              {name}
            </Link>
          </h4>
          <p>{description}</p>
          <span className="service-link-label">{linkLabel}</span>
        </article>
      </div>
    );
  }

  return (
    <section id="services" className="services section light-background">
      <div className="container section-title" data-aos="fade-up">
        <h2>Selected Work</h2>
        <p>
          We support client delivery and grow our own products, giving us room
          to solve immediate business needs while investing in bigger ideas.
        </p>
        <div className="section-page-link">
          <Link to="/services" className="read-more">
            <span>See our services</span>
            <i className="bi bi-arrow-right"></i>
          </Link>
        </div>
      </div>

      <div className="container">
        <div className="row gy-4">
          {workItems.map((item, index) => (
            <ServiceItem
              key={item.name}
              delay={`${(index + 1) * 100}`}
              description={item.description}
              image={item.image}
              linkLabel={item.linkLabel}
              name={item.name}
              slug={item.slug}
              type={item.type}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
